"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "buttonSize", {
  enumerable: true,
  get: function get() {
    return _oxygenConstants.buttonSize;
  }
});
Object.defineProperty(exports, "ButtonGroup", {
  enumerable: true,
  get: function get() {
    return _ButtonGroup["default"];
  }
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash.noop"));

var _oxygenConstants = require("@8x8/oxygen-constants");

var _oxygenConfig = require("@8x8/oxygen-config");

var _themeName = _interopRequireDefault(require("./constants/themeName"));

var _ButtonGroup = _interopRequireDefault(require("./components/ButtonGroup"));

var ButtonStyled = _interopRequireWildcard(require("./styled/button.styled"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Button = /*#__PURE__*/function (_Component) {
  _inherits(Button, _Component);

  var _super = _createSuper(Button);

  function Button() {
    _classCallCheck(this, Button);

    return _super.apply(this, arguments);
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var ButtonContainer = this.props.secondary ? ButtonStyled.SecondaryContainer : ButtonStyled.PrimaryContainer;

      var _this$props = this.props,
          as = _this$props.as,
          children = _this$props.children,
          isDisabled = _this$props.isDisabled,
          forwardedRef = _this$props.forwardedRef,
          restProps = _objectWithoutProperties(_this$props, ["as", "children", "isDisabled", "forwardedRef"]);

      return /*#__PURE__*/_react["default"].createElement(ButtonContainer, _extends({
        as: as,
        disabled: isDisabled,
        ref: forwardedRef
      }, restProps), children);
    }
  }], [{
    key: "getStyledContainer",
    value: function getStyledContainer() {
      return ButtonStyled.PrimaryContainer;
    }
  }]);

  return Button;
}(_react.Component);

Button.propTypes = {
  /**
   * Represents the DOM Node tag of the rendered Button (by default is 'button').
   * Value can be any valid html tag name
   */
  as: _propTypes["default"].string,

  /**
   * Button type: primary/secondary
   */
  secondary: _propTypes["default"].bool,

  /**
   * Specifies the size of the button
   */
  size: _propTypes["default"].oneOf([_oxygenConstants.buttonSize.small, _oxygenConstants.buttonSize.big]),

  /**
   * Enable/disable the active state of the button
   */
  isActive: _propTypes["default"].bool,

  /**
   * Disables the button
   */
  isDisabled: _propTypes["default"].bool,

  /**
   * Specifies if the button has shadow
   */
  hasShadow: _propTypes["default"].bool,

  /**
   * Represents the DOM Attribute type of the rendered Button (by default is 'button').
   * Can have as value one of 'button', 'submit' or 'reset'
   */
  type: _propTypes["default"].string,

  /**
   * Title attribute
   */
  title: _propTypes["default"].string,

  /**
   * Application testId
   */
  testId: _propTypes["default"].string,

  /**
   * Click callback function
   */
  onClick: _propTypes["default"].func,

  /**
   * Button content
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,

  /**
   * Button component ref
   */
  className: _propTypes["default"].string,
  forwardedRef: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]),
  theme: _propTypes["default"].object.isRequired
};
Button.defaultProps = {
  as: 'button',
  secondary: false,
  size: _oxygenConstants.buttonSize.big,
  isActive: false,
  isDisabled: false,
  hasShadow: undefined,
  type: 'button',
  title: '',
  onClick: _lodash["default"],
  className: undefined,
  forwardedRef: null,
  testId: 'BUTTON'
};

var _default = (0, _oxygenConfig.withTheme)(Button, _themeName["default"]);

exports["default"] = _default;